module.exports = __webpack_public_path__ + "img/sentiment_very_dissatisfied.c25fc05f.png";